const ExploreFarData27 = [
  {
    title: "Leo Carrillo Ranch Historic Park",
    description: `Actor Leo Carrillo (best known for The Cisco Kid) built this Spanish hacienda-style retreat in 1937 as a Hollywood getaway, entertaining guests like Clark Gable and Carole Lombard. Now a free, National Historic Landmark with restored adobe buildings and dozens of free-roaming peacocks. Guided tours are offered on Saturdays.`,
    distance: 3.7,
  },
  {
    title: "San Diego Botanic Garden",
    description: `Explore a staggering 37 acres of gardens in Encinitas with four miles of trails winding through 29 themed areas, including the largest public bamboo collection in North America, desert gardens, and a tropical rainforest.`,
    distance: 3.4,
  },
  {
    title: "Beaches",
    description: `Four distinct beaches within a short distance of the resort, ranging from the surf-friendly breaks at South Ponto to the wide, family-friendly stretch at Moonlight. The resort runs a daily shuttle to the coast; check with the bell desk to reserve your spot.
    <ul>
    <li>South Ponto — 5.3 miles away</li>
    <li>Moonlight State Beach — 5.7 miles away</li>
    <li>Terramar — 6.3 miles away</li>
    <li>Carlsbad State Beach — 9.0 miles away</li>
    </ul>
    Fun Fact: Carlsbad is the birthplace of the Morey Boogie Board, invented by local resident Tom Morey in 1971, so a bodyboard rental feels appropriately on-theme!`,
    distance: 5.3,
  },
  {
    title: "Carlsbad Premium Outlets",
    description: `Scratch your shopping itch at 85+ designer outlet stores, including Nike, Tory Burch, Adidas, Coach, Johnny Was, and Kate Spade!`,
    distance: 5.2,
  },
  {
    title: "LEGOLAND California Resort",
    description: `More than 60 rides, shows, and attractions built around 60+ million LEGO bricks, plus the SEA LIFE Aquarium and a full water park, all on the same campus. Check it out for a surprisingly enjoyable afternoon, even if you're not traveling with kids.`,
    distance: 6.2,
  },
  {
    title: "Museum of Making Music",
    description: `This museum offers a chronological journey through 100+ years of American popular music, tracing how instruments evolved alongside the songs we know. Many exhibits are hands-on, so you can pick up and play throughout.`,
    distance: 5.0,
  },
  {
    title: "Agua Hedionda Lagoon Discovery Center",
    description: `A free (suggested donation) nature center on the edge of Carlsbad's 400-acre coastal lagoon. Exhibits include a live observation beehive, aquariums, mastodon bone finds, and a sanctuary for injured birds of prey, plus live animals you can actually hold, including reptiles, tortoises, and snakes. Open Tuesday through Sunday.`,
    distance: 6.0,
  },
  {
    title: "Carlsbad Village Farmers Market",
    description: `Every Wednesday on State Street in Carlsbad Village, with local produce, prepared foods, and handmade goods. A good option if you're looking for a low-key morning before sessions start.`,
    distance: 8.7,
  },
  {
    title: "Carlsbad Village & Historic Highway 101",
    description: `The walkable heart of old Carlsbad, with shops, restaurants, and the historic Santa Fe Depot (now the visitor center). It's also home to the city's two Michelin-starred restaurants, Jeune et Jolie and Lilo, both worth a reservation if your group wants a special dinner out.`,
    distance: 8.6,
  },
  {
    title: "Carlsbad Food Tours",
    description: `Savor your way through Carlsbad Village on a guided food tour, with tastings at local restaurants and stories about the city's history, architecture, and culinary roots. Book in advance at carlsbadfoodtours.com.`,
    distance: null,
    url: "https://carlsbadfoodtours.com",
  },
  {
    title: "The Magee House",
    description: `A craftsman-style home built in 1887, now home to the Carlsbad Historical Society and a nationally registered rose garden with 125+ varieties. A nice stop along Historic Highway 101 for anyone interested in history or plants.`,
    distance: 10,
  },
  {
    title: "Carlsbad Historic Artesian Well",
    description: `The original artesian well, first drilled in 1882, whose discovery put Carlsbad on the map and gave the city its name (after Karlsbad, the famous Bohemian spa town). Visitors can view the restored well, learn the backstory, and pick up a bottle of the alkaline mineral water.`,
    distance: 10,
  },
  {
    title: "67 Miles of City Trails",
    description: `Carlsbad maintains an extensive trail network, including:
    <ul>
    <li><strong>Batiquitos Lagoon Trail</strong> — 3 miles away (2.7 miles; easy): Flat, shaded path along the lagoon</li>
    <li><strong>Lake Calavera Loop</strong> — 8.3 miles away (moderate): Climbs a volcanic plug with ocean views and a cave on the way down</li>
    <li><strong>Hosp Grove Trail</strong> — 10.0 miles away (3 miles; moderate to difficult): Through mature eucalyptus groves with views of Buena Vista Lagoon and the Pacific Ocean</li>
    <li><strong>Crossings / Veterans Park Trail</strong> — 4.5 miles away (4 miles; moderate to difficult): Panoramic views of Agua Hedionda Lagoon and the coastline, a favorite for sunset</li>
    </ul>`,
    distance: 3,
  },
];

export default ExploreFarData27;
